import EnrollmentConversionTableContent from 'automation-ui-canvas/containers/enrollment-conversion/panel/table/EnrollmentConversionTableContent';
import { FLOW_BY_VERSION_ID_FIELD_NAME, GET_FLOW_BY_VERSION_ID } from 'automation-ui-canvas/containers/enrollment-history/utils/flowByRevisionQueries';
import Flow from 'automation-ui-canvas/flow/records/Flow';
import { useQuery } from 'data-fetching-client';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const EnrollmentConversionSidePanelContent = ({
  flowId,
  isReportingEnabled
}) => {
  const {
    search
  } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const versionId = searchParams.get('version');
  const {
    data: {
      [FLOW_BY_VERSION_ID_FIELD_NAME]: {
        flow: currentVersionGroupFlow = null
      } = {}
    } = {},
    loading: isFlowLoading,
    error: flowError
  } = useQuery(GET_FLOW_BY_VERSION_ID, {
    skip: !versionId,
    variables: {
      flowId,
      versionId
    }
  });
  if (isFlowLoading || flowError) {
    return null;
  }
  return /*#__PURE__*/_jsx(EnrollmentConversionTableContent, {
    currentVersionGroupFlow: new Flow(currentVersionGroupFlow),
    isReportingEnabled: isReportingEnabled
  });
};
export default EnrollmentConversionSidePanelContent;